import { GzEdrSensorGeneralWebComponent } from './component/GzEdrSensorGeneralWebComponent';

export { GzEdrSensorGeneralWebComponent };
